var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div ng-show=\"past_bookings.length == 0\">\n<h3 translate=\"MEMBER.MEMBER_PAST_BOOKINGS.NO_PAST_BOOKINGS\"></h3>\n</div>\n<div class=\"bb-section\">\n<ul class=\"bb-list bb-list-bordered\">\n<li bb-member-booking=\"booking\" ng-repeat=\"booking in past_bookings | filter:{deleted: false} | startFrom: (pagination.current_page - 1) * pagination.page_size | limitTo: pagination.page_size\">\n</li>\n</ul>\n</div>\n<div uib-pagination total-items=\"pagination.num_items\" ng-model=\"pagination.current_page\" items-per-page=\"pagination.page_size\" max-size=\"pagination.max_size\" boundary-links=\"true\" rotate=\"false\" num-pages=\"pagination.num_pages\" ng-show=\"past_bookings && past_bookings.length > 10\">\n</div>\n</div>\n";
var id1="member/member-past-bookings/member_past_bookings.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
exports.id=id1;
exports.template=v1;


//////////////////
// WEBPACK FOOTER
// ../node_modules/bookingbug-angular/src/member/member-past-bookings/member_past_bookings.html
// module id = 1181
// module chunks = 0